import React, {useState, useRef, useCallback, useEffect, createContext} from 'react';
//import {postApi} from './functions';

export const WebContext = createContext();

export const WebProvider = (props) => {
	const [web, setWeb] = useState({});

	useEffect(() => {
    async function loadService() {
      let res = await fetch(`./config.js`);
      res = await res.json();
      for( let i in res.schedule ) {
        res.schedule[i].date = new Date(res.schedule[i].date);
        for( let j in res.schedule[i].events ) {
          res.schedule[i].events[j].start = new Date(res.schedule[i].events[j].start);
          res.schedule[i].events[j].end = new Date(res.schedule[i].events[j].end);
        }
      }
      //console.log(res);
      setWeb(res);
    }
    loadService();
  }, []);
	
  return web.service ? (
		<WebContext.Provider value={{web, setWeb}}>
			{props.children}
		</WebContext.Provider>
	) : null;
}